'use strict';
var customerGroups = document.cookie.split(';').find(cookie => cookie.trim().toLowerCase().startsWith('customergroups'));
const isLoggedIn = customerGroups && customerGroups.includes('registered');

module.exports = {
    updateOrderLink: function (link) {
        var $orderLink = $('#sub-nav-track-order');
        var $orderLabel = $orderLink.find('.track-order-label');

        $orderLink.attr('href', link);
        $orderLabel.text('Track Order');
        $orderLink.removeClass('d-none');
    },
    initTrackOrder: function () {
        module.exports.updateOrderLink('/order/search');

        let cachedData = sessionStorage.getItem('preferredAddress');
        if (cachedData) {
            module.exports.updateOrderLink('/orders');
        } else if (isLoggedIn) {
            /* This will 500 if the user isn't logged in. */
            $.ajax({
                url: '/on/demandware.store/Sites-gamestop-us-Site/default/Address-AddressBook',
                method: 'GET',
                success: function (data) {
                    if (data.preferredAddress) {
                        module.exports.updateOrderLink('/orders');
                        sessionStorage.setItem('preferredAddress', JSON.stringify({ city: data.preferredAddress.city, postalCode: data.preferredAddress.postalCode }));
                    }
                }
            });
        }
    }
};
